export const SETTING_SIDEBAR_ZUSAMMENARBEIT = 45;
export const SETTING_SIDEBAR_DASHBOARD = 46;
export const SETTING_SIDEBAR_INTRANET = 47;
export const SETTING_SIDEBAR_EINSTELLUNGEN = 48;

export function isPlatformSettingEnabled(settings, settingId) {
  if (!settings) {
    return true;
  }

  const entry = Array.isArray(settings)
    ? settings.find(setting => Number(setting.id) === Number(settingId))
    : settings[settingId] || settings[String(settingId)];

  if (!entry) {
    return true;
  }

  return Number(entry.enabled) === 1;
}

/**
 * Settings für die Sidebar-Sichtbarkeit: immer der übergeordnete (Heimat-)Mandant.
 * Nach Mandantenwechsel dürfen die Kunden-Settings nicht greifen.
 */
export function resolveSidebarPlatformSettings({
  user,
  logisticCompanyId = 0,
  homePlatformSettings,
  platformSettings
}) {
  if (homePlatformSettings) {
    return homePlatformSettings;
  }

  const homeTenantId = user?.logisticcompany_id;
  if (!homeTenantId) {
    return platformSettings;
  }

  const activeTenantId =
    logisticCompanyId === 0 ? homeTenantId : logisticCompanyId;

  if (activeTenantId === homeTenantId) {
    return platformSettings;
  }

  return null;
}
